export default {
  // userInfo: state => state.user.userInfo
  menuList: state => state.user.menuList,
  marks: state => state.mark.marks,
  notes: state => state.note.notes,
  isTra: state => state.other.isTra,
  userInfo: state => state.user.userInfo,
  confidentialSourceIds: state => state.other.confidentialSourceIds,
  library: state => state.user.library
}
